var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellMuted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2.5L13 13.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12V12.5C6 13.0304 6.21071 13.5391 6.58579 13.9142C6.96086 14.2893 7.46957 14.5 8 14.5C8.53043 14.5 9.03914 14.2893 9.41421 13.9142C9.78929 13.5391 10 13.0304 10 12.5V12",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6363 11.9999H3.0614C2.97348 11.9997 2.88717 11.9763 2.81118 11.9321C2.73519 11.8878 2.67221 11.8244 2.62859 11.748C2.58498 11.6717 2.56227 11.5852 2.56275 11.4972C2.56324 11.4093 2.5869 11.3231 2.63136 11.2472C3.04406 10.5372 3.51261 9.23831 3.51261 6.99995V6.49995C3.51104 5.58541 3.78892 4.69222 4.30903 3.93997",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7821 2.58715C6.46758 2.19551 7.24476 1.99291 8.03419 2.00006C10.5085 2.01846 12.4877 4.07514 12.4877 6.55643V6.99994C12.4877 8.66669 12.7474 9.81256 13.0503 10.5822",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellMuted);
export default __webpack_public_path__ + "static/media/bell-muted.7d2ebbda684b5bca00996ba33971a840.svg";
export { ForwardRef as ReactComponent };